import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useSearchParams } from 'react-router-dom';
import { Box, ThemeProvider } from '@mui/material';
import theme from '../theme';
import EasywebinarLogin from '../pages/Archives/EasywebinarLogin';
import OverView from '../designer/account-settings/Dashboard';
import UmbrellaSignUp from '../designer/umbrella-signUp/umbrella-signUp';
import EasyWebinarsignUp from '../designer/easyWebinar-signUp/easyWebinar-signUp';
import EasysuiteWelcomeDashboard from '../designer/easysuiteWelcomeDashbord/EasysuiteWelcomeDashboard';
import Dashboard from '../pages/Dashboard';
import Signup from '../pages/Signup';
import Login from '../pages/Login';
import Logout from '../pages/Logout';
import ForgotPassword from '../pages/ForgotPassword';
import VerifyCode from '../components/VerifyCode';
import SSOSignup from '../pages/SSOSignup';
import SSOCallback from '../pages/SsoCallback';
import LoginOTP from '../pages/LoginOTP';
import ProtectedRoute from './ProtectedRoute';
import RedirectIfAuthenticated from './RedirectIfAuthenticated';
import LoadingDashboard from '../pages/LoadingDashboard';
import LinkAccount from '../pages/LinkAccount';
import SuperAdmin from '../pages/SuperAdmin';
import NotFound from '../pages/NotFound';
import SignupSale from '../pages/SignupSale';
import SSOSignupSale from '../pages/SSOSignupSale';
import LoginSale from '../pages/LoginSale';
import { config } from '../config';
import Signup2ndFlow from '../pages/Signup2ndFlow';
import LiveAuditWorkshopOfferMain from '../pages/LiveAuditWorkshopOffer-Main';
import LiveAuditWorkshopOfferVariation from '../pages/LiveAuditWorkshopOffer-Variation';
import SignupOctoberSale from '../pages/Signup-october-sale';
import SignupTrialWithoutCard from '../pages/Signup-trial-without-card';
import Signup2ndFlowSale from '../pages/Signup2ndFlowSale';
import WebinarconSignup from '../pages/Webinarcon-Signup';
import WebinarconLifetimeSignup from '../pages/Webinarcon-Lifetime-Signup';
import WebinarconAgencyBundleSignup from '../pages/Webinarcon-Agency-Bundle-Signup';

// Dynamic Signup Component
const DynamicSignup: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Get saleVersion from query parameter first, then localStorage, default to 'true'
  const querySaleVersion = searchParams.get('saleVersion');
  const storedSaleVersion = localStorage.getItem('saleVersion');
  const saleVersion = querySaleVersion || storedSaleVersion || 'true';
  
  useEffect(() => {
    // Always update localStorage with current saleVersion
    localStorage.setItem('saleVersion', saleVersion);
  }, [saleVersion]);
  
  // Show sale version if config.isSaleLive is true AND saleVersion is 'true'
  const shouldShowSale = config.isSaleLive && saleVersion === 'true';
  
  //return shouldShowSale ? <SignupSale /> : <Signup />;
  return <Signup />;
};

// Dynamic SignupFlowSale Component
const DynamicSignupFlowSale: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Get saleVersion from query parameter first, then localStorage, default to 'true'
  const querySaleVersion = searchParams.get('saleVersion');
  const storedSaleVersion = localStorage.getItem('saleVersion');
  const saleVersion = querySaleVersion || storedSaleVersion || 'true';
  
  useEffect(() => {
    // Always update localStorage with current saleVersion
    localStorage.setItem('saleVersion', saleVersion);
  }, [saleVersion]);
  
  // Show sale version if config.isSaleLive is true AND saleVersion is 'true'
  const shouldShowSale = config.isSaleLive && saleVersion === 'true';
  
  //return shouldShowSale ? <SignupSale /> : <Signup />;
  return <Signup2ndFlow />;
};

// Dynamic Login Component
const DynamicLogin: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Get saleVersion from query parameter first, then localStorage, default to 'true'
  const querySaleVersion = searchParams.get('saleVersion');
  const storedSaleVersion = localStorage.getItem('saleVersion');
  const saleVersion = querySaleVersion || storedSaleVersion || 'true';
  
  useEffect(() => {
    // Always update localStorage with current saleVersion
    localStorage.setItem('saleVersion', saleVersion);
  }, [saleVersion]);
  
  // Show sale version if config.isSaleLive is true AND saleVersion is 'true'
  const shouldShowSale = config.isSaleLive && saleVersion === 'true';
  
  //return shouldShowSale ? <LoginSale /> : <Login />;
  return <Login />;
};

// Dynamic SSO Signup Component
const DynamicSSOSignup: React.FC = () => {
  const [searchParams] = useSearchParams();
  
  // Get saleVersion from query parameter first, then localStorage, default to 'true'
  const querySaleVersion = searchParams.get('saleVersion');
  const storedSaleVersion = localStorage.getItem('saleVersion');
  const saleVersion = querySaleVersion || storedSaleVersion || 'true';
  
  useEffect(() => {
    // Always update localStorage with current saleVersion
    localStorage.setItem('saleVersion', saleVersion);
  }, [saleVersion]);
  
  // Show sale version if config.isSaleLive is true AND saleVersion is 'true'
  const shouldShowSale = config.isSaleLive && saleVersion === 'true';
  
  //return shouldShowSale ? <SSOSignupSale /> : <SSOSignup />;
  return <SSOSignup />;
};

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route 
        path="/ew-login" 
        element={
          <RedirectIfAuthenticated>
            <EasywebinarLogin />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/login" 
        element={
          <RedirectIfAuthenticated>
            <DynamicLogin />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/login-support" 
        element={
          <RedirectIfAuthenticated>
            <LoginOTP />
          </RedirectIfAuthenticated>
        } 
      />
      <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <ThemeProvider theme={theme}><Box sx={{ 
                '& .MuiTypography-root': {
                  fontFamily: "'Roboto', sans-serif"
                }
              }}><Dashboard /></Box></ThemeProvider>
            </ProtectedRoute>
          }
      />
      <Route 
        path="/signup" 
        element={
          <RedirectIfAuthenticated>
            <DynamicSignup />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/signup-flow" 
        element={
          <RedirectIfAuthenticated>
            <DynamicSignupFlowSale />
          </RedirectIfAuthenticated>
        } 
      />
      <Route 
        path="/loading-dashboard" 
        element={
            <LoadingDashboard />
        } 
      />
      <Route 
        path="/link-account" 
        element={
            <LinkAccount />
        } 
      />
      <Route path="/logout" element={<Logout />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verify-code" element={<VerifyCode />} />
      <Route 
        path="/sso-signup" 
        element={
            <DynamicSSOSignup />
        } 
      />
      <Route path="/auth/sso/callback" element={<SSOCallback />} />
      <Route path="/designer">
        <Route path="login" element={<Login />} />
        <Route path="umbrellaSignUp" element={<UmbrellaSignUp />} />
        <Route path="easyWebinarSignUp" element={<EasyWebinarsignUp />} />
        <Route path="dashboard" element={<OverView />} />
        <Route path="easysuite-dashboard" element={<EasysuiteWelcomeDashboard />} />
      </Route>
      <Route 
        path="/super-admin" 
        element={
          <ProtectedRoute>
            <ThemeProvider theme={theme}>
              <Box sx={{ 
                '& .MuiTypography-root': {
                  fontFamily: "'Roboto', sans-serif"
                }
              }}>
                <SuperAdmin />
              </Box>
            </ThemeProvider>
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/live-audit-workshop-offer" 
        element={
            <LiveAuditWorkshopOfferMain />
        } 
      />

      <Route 
        path="/live-audit-workshop-offer-fa" 
        element={
        <LiveAuditWorkshopOfferVariation />
        // <Navigate to="/live-audit-workshop-offer" replace />
      } 
      />

      <Route 
        path="/signup/professional-plan-october-sale" 
        element={
            <SignupOctoberSale/>
        } 
      />

      <Route 
        path="/signup-free-trial" 
        element={
          <RedirectIfAuthenticated>
            <SignupTrialWithoutCard/>
          </RedirectIfAuthenticated>
        } 
      />

      <Route 
        path="/sales-experience-signup" 
        element={
          <RedirectIfAuthenticated>
            <WebinarconSignup/>
          </RedirectIfAuthenticated>
        } 
      />

      <Route 
        path="/lifetime-professional-signup" 
        element={
          <RedirectIfAuthenticated>
            <WebinarconLifetimeSignup/>
          </RedirectIfAuthenticated>
        } 
      />

      <Route 
        path="/agency-bundle-signup" 
        element={
          <RedirectIfAuthenticated>
            <WebinarconAgencyBundleSignup/>
          </RedirectIfAuthenticated>
        } 
      />
      
      {/* Catch-all route for 404 page */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;